import _ from 'lodash';
import Base from './base';

export default class ServiceType extends Base {
    static fields = {
        name: String,
    }
    static searchConfig = [{
            icon: 'mdi-format-text',
            label: 'Naam',
            type: 'property',
            filter: 'name'
        },
        {
            icon: 'mdi-format-text',
            label: 'Omschrijving',
            type: 'property',
            filter: 'description'
        },
    ];
}